module.exports = __webpack_public_path__ + "img/0922_2.088d05f2.jpg";